export async function getInvitationLink(inviteCode: string) {
  return `https://base-link.web.app/authSelector/?inviteCode=${inviteCode}`;
}
